import Swal from "sweetalert2";
import {Alert} from "antd"
 
export const successAlertAntd = (numero)=>{
  
    <Alert
    type="success" 
    message="success"
    description="Affectation accept�e"
    closable
    />
  
}
export const successAlertWithoutTime = (numero) => {
  return Swal.fire({
    title: "SUCCESS!",
   // text: numero,
    icon: "success",
    html: numero ,
    confirmButtonText: "Cool",
  });
};
export const successAlert = (numero) => {
  return Swal.fire({
    title: "SUCCESS!",
    text: numero,
    icon: "success",
    timer: 3000,
    confirmButtonText: "Cool",
  });
};
export const errorAlert = (numero) => {
  return Swal.fire({
    title: "Error!",
    text: numero,
    icon: "error",
    // timer: 3000,
    confirmButtonText: "Ok",
  });
};

/**
 * Recapitulatif unique de la chaine Alarme (statut appel -> statut contact -> qualification).
 *
 * @param resultats { appel, statutContact, qualification }
 *        chaque entree : { etat: "ok" | "echec" | "nonSaisi" | "nonApplicable", libelle }
 *
 * ATTENTION : ce fichier est encode en cp1252, pas en UTF-8. Tout caractere non-ASCII
 * ecrit ici ressort casse dans le navigateur (le bundler lit le source comme de l'UTF-8).
 * On n'utilise donc que de l'ASCII + des entites HTML.
 */
export const recapChaineAlarmeAlert = (resultats) => {
  const echapper = (texte) =>
    String(texte == null ? "" : texte)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");

  const construireLigne = (titre, resultat) => {
    const etat = resultat?.etat || "nonSaisi";
    const libelle = echapper(resultat?.libelle);
    const valeur = libelle ? ` &laquo;&nbsp;${libelle}&nbsp;&raquo;` : "";

    if (etat === "nonApplicable") {
      return `<div style="color:#9e9e9e">&#9679; <b>${titre}</b> : non requis pour ce statut</div>`;
    }
    if (etat === "ok") {
      return `<div style="color:#2e7d32">&#10003; <b>${titre}</b>${valeur} enregistr&eacute;</div>`;
    }
    if (etat === "echec") {
      return `<div style="color:#c62828">&#10007; <b>${titre}</b>${valeur} <b>NON enregistr&eacute;</b> &mdash; &agrave; saisir manuellement sur la fiche</div>`;
    }
    return `<div style="color:#ef6c00">&#9888; <b>${titre}</b> non saisi${valeur} &mdash; &agrave; compl&eacute;ter sur la fiche</div>`;
  };

  const auMoinsUnEchec = [
    resultats?.appel,
    resultats?.statutContact,
    resultats?.qualification,
  ].some((r) => r?.etat === "echec");

  const html = [
    `<div style="text-align:left;font-size:0.95rem;line-height:1.8">`,
    construireLigne("Statut appel", resultats?.appel),
    construireLigne("Statut contact", resultats?.statutContact),
    construireLigne("Qualification", resultats?.qualification),
    `</div>`,
  ].join("");

  return Swal.fire({
    title: auMoinsUnEchec ? "Saisie incompl&egrave;te" : "Saisie enregistr&eacute;e",
    icon: auMoinsUnEchec ? "warning" : "success",
    html,
    timer: auMoinsUnEchec ? undefined : 5000,
    confirmButtonText: "Ok",
  });
};
export const uploadErrorAlert = (numero) => {
  return Swal.fire({
    title: "SUCCESS!",
    text: numero,
    icon: "success",
    timer: 3000,
    confirmButtonText: "Cool",
  });
};